import React from 'react';
import {
  Box,
  Typography,
  Grid as MuiGrid,
  Paper,
  IconButton,
  Link,
} from '@mui/material';
import { motion } from 'framer-motion';
import {
  GitHub as GitHubIcon,
  LinkedIn as LinkedInIcon,
  Email as EmailIcon,
} from '@mui/icons-material';

const MotionPaper = motion.create(Paper);
const Grid = MuiGrid as any;

const socialLinks = [
  {
    name: 'LinkedIn',
    icon: <LinkedInIcon />,
    url: 'https://linkedin.com/in/suliot',
  },
  {
    name: 'GitHub',
    icon: <GitHubIcon />,
    url: 'https://github.com/msuliot',
  },
  {
    name: 'Email',
    icon: <EmailIcon />,
    url: 'mailto:michael@suliot.com',
  },
];

const Contact = () => {
  return (
    <Box sx={{ py: { xs: 2, md: 4 } }}>
      <Typography variant="h4" component="h1" gutterBottom>
        Contact Me
      </Typography>
      
      <Grid container spacing={4}>
        <Grid sx={{ gridColumn: { xs: 'span 12', md: 'span 8' } }}>
          <MotionPaper
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5 }}
            sx={{
              p: { xs: 2, md: 3 },
              backgroundColor: 'background.paper',
              borderRadius: 2,
            }}
          >
            <Typography variant="h6" component="h2" gutterBottom>
              Get in Touch
            </Typography>
            <Typography variant="body1" paragraph>
              Feel free to reach out to me for any opportunities or just to say hello!
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
              <EmailIcon sx={{ mr: 1, color: 'primary.main' }} />
              <Link href="mailto:michael@suliot.com" color="inherit">
                michael@suliot.com
              </Link>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
              <Typography variant="body1" sx={{ mr: 1 }}>
                Location:
              </Typography>
              <Typography variant="body1" color="text.secondary">
                Gilbert, AZ 85298
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
              <Typography variant="body1" sx={{ mr: 1 }}>
                Phone:
              </Typography>
              <Typography variant="body1" color="text.secondary">
                480-773-5608 (mobile)
              </Typography>
            </Box>
            <Box sx={{ mt: 3 }}>
              <Typography variant="subtitle1" gutterBottom>
                Connect with me on social media:
              </Typography>
              <Box sx={{ display: 'flex', gap: 2 }}>
                {socialLinks.map((link) => (
                  <IconButton
                    key={link.name}
                    href={link.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    color="primary"
                    sx={{ '&:hover': { backgroundColor: 'rgba(0, 188, 212, 0.08)' } }}
                  >
                    {link.icon}
                  </IconButton>
                ))}
              </Box>
            </Box>
          </MotionPaper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Contact; 